import React, { useRef, useEffect, useCallback, useState} from 'react';
import OscillatorWaveform from './OscillatorWaveform.js';
import {useMixerMouse} from './useMixerMouse.js';
import {getHeight} from 'components/cirklon/useParameterMouse.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK = 250;

const OperatorMixer = ({
    color,
    value,
    oscillator,
    height=75,
    setOscillatorDetails,
    oscillatorDetails
}) => { 
    const ref = useRef(undefined);
    const lastClick = useRef(0);

    let style = {
        height: getHeight(value, 0, 1, height, 1),
        backgroundColor: color
    };

    const round = (x) => {
        return Math.round(x*100) / 100;
    };

    const {onMouseDown, onMouseMove, onMouseClear} = useMixerMouse({
        height,
        parameter: oscillator.oscillatorLevelParameter,
        min: 0,
        max: 1,
        ref
    });

    let nameClass ="operator-name";
    if (oscillatorDetails === oscillator) {
        nameClass += " selected";
    }

    let disabled = !oscillator.enabledParameter.get();
    if (disabled) {
        nameClass += " disabled";
    }

    const onClickName = useCallback(() => {
        let now = new Date().getTime();
        if (now - lastClick.current < DOUBLE_CLICK) {
            let setting = !oscillator.enabledParameter.get();
            oscillator.enabledParameter.set(setting);
            if (!setting) {
                setOscillatorDetails(undefined);
                return;
            }
        }

        lastClick.current = now;
        if (!oscillator.enabledParameter.get()) {
            return;
        }

        setOscillatorDetails(
            oscillatorDetails === oscillator ? undefined :
                oscillator);
    }, [oscillatorDetails, oscillator, setOscillatorDetails]);

    return (
        <div className="operator-mixer">
          <div
            onClick={onClickName}
            className={nameClass}>
            {oscillator.name}
          </div>
          {!oscillatorDetails && !disabled ? 
          <div
            draggable={true}
            onDragStart={(e) => e.preventDefault()}
            ref={ref}
            style={{
                height: height + 6,
            }}
            onClick={(e) => e.stopPropagation()}
            onMouseLeave={onMouseClear}
            onMouseUp={onMouseClear}
            onMouseMove={onMouseMove}
            onMouseDown={onMouseDown}
            className="volume-box">
            <div className="rest"/>
            <div
              style={style}
              className="volume-indicator">
            </div>
            <div className="value">
              {round(value)}
            </div>
          </div>
           : ''}
          {(!oscillatorDetails || oscillatorDetails === oscillator) && !disabled ? 
          <OscillatorWaveform
            oscillator={oscillator}/>
         : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
    let param = props.oscillator.oscillatorLevelParameter;
    return {
      value: state.effects.effectParameters[param.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorMixer);
